import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

const allowedLanguages = ["en", "ar"];
const defaultLng = "en";
let lng = window.lang;
// console.log("i18n - window.lang => " + lng);

const storageLanguage = localStorage.getItem("language");
if (storageLanguage && allowedLanguages.indexOf(storageLanguage) > -1) {
  lng = window.lang;
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng,
    debug: true,
    keySeparator: false,
    fallbackLng: defaultLng,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath:
        "/.forgot.password/react-app/build/translations/{{lng}}.json",
      allowMultiLoading: true,
    },
    react: {
      wait: true,
      useSuspense: true,
    },
  });

export default i18n;
